export default __webpack_public_path__ + "telegram-logo.df3a91becaa9678c529b4c4cadd45204.svg";